<template>
    <div class="echarts" :style="`width: ${this.width};height: ${this.height}`">
        <div :style="`width: ${this.width};height: ${this.height}`" :id="this.id"></div>
    </div>
</template>

<script>
import moment from 'moment'
import Vue from 'vue'
export default {
    props: ['width', 'height', 'label', 'data', 'id'],
    watch: {
        data(arr) {
            this.init()
        }
    },
    mounted() {
        //this.init()
    },
    methods: {
        init() {
            this.charts = this.echarts.init(document.getElementById(this.id))

            //重置数据
            this.charts_option.series[0].data = this.data.seriesData
            this.charts_option.xAxis.data = this.data.xAxisData

            this.charts.setOption(this.charts_option)    
        },
    },
    data() {
        return {
            charts: '',
            charts_option : {
				tooltip: {
                    extraCssText: 'box-shadow: 0 1px 12px 1px rgba(191,191,191,0.7);border-radius:3px;line-height:24px;',
                    trigger: 'axis',
                    backgroundColor: '#fff',
                    padding: 10,
                    formatter: (params) => {
                        let total = params.reduce((acc, cur) => (acc + cur.value), 0);
                        if(/^0\d+/.test(total)) total = total.slice(1)
                        const[formatData] = params;
                        const timeStr = moment(formatData.axisValue).format('M月D日');
                        const headerStr = `<p style="color: #000;font-size: 12px" >${timeStr}${this.label}<strong style="margin-left: 33px;font-size: 15px">${total}</strong><p>`;
                        const contentStr = params.map(item => `<p>
                        <span style="float: right;color: rgba(0,0,0,0.65);">${item.value}</span ><span style = "float: left;
                            margin-top: 10px;
                            background-color: ${item.color};
                            width: 4px;
                            height: 4px;
                            border-radius: 50%;"> </span>
                        <span
                            style="color: rgba(0,0,0,0.325);
                            font-size:12px;
                            margin-top: 8px;
                            margin-left: 10px;">
                            ${item.seriesName}
                        </span></p>`)
                        .join('');
                        return `<div style = "margin: 0 6px;">${headerStr}${contentStr} </div>`;
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.data.xAxisData || [],
                    axisLine: {
                        lineStyle: {
                            color: '#d8d8d8',
                            width: 0.5,
                            type: 'dashed',
                        },
                    },
                    axisLabel: {
                        color: 'rgba(0,0,0,0.45)',
                    },
                },
                yAxis: {
                    type: 'value',
                    offset: 10,
                    minInterval: 1,
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        color: 'rgba(0,0,0,0.45)',
                        formatter(value) {
                            return value % 1 === 0 ? value: '';
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#d8d8d8',
                            width: 0.5,
                            type: 'dashed',
                        },
                    },
                },
                series: [
				    {
                        name: '酷狗音乐',
                        type: 'line',
                        lineStyle: {
                            width: 2,
                            color: '#0090ff',
                        },
                        itemStyle: {
                            color: '#0090ff',
                        },
                        data: this.data.seriesData || [],
                    }
				],
			},
        }
    },
}
</script>

<style lang="scss" scoped>
    .echarts {
        margin: 0 auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/Echarts/Echarts.vue